<script lang="ts" setup>
const iconSize = "50px";
const localePath = useLocalePath();
</script>

<template>
  <footer class="footer-container">
    <div class="social">
      <a href="https://www.facebook.com/KatarraktisRefuge" target="_blank" rel="noopener noreferrer">
        <Icon :size="iconSize" name="mdi:facebook" aria-hidden="true"/>
        <span class="sr-only">{{ $t('visitFacebookPage') }} ({{ $t('opensInNewTab') }})</span>
      </a>
      <a href="https://www.instagram.com/katarraktis.refuge/" target="_blank" rel="noopener noreferrer">
        <Icon :size="iconSize" name="mdi:instagram" aria-hidden="true"/>
        <span class="sr-only">{{ $t('visitInstagramPage') }} ({{ $t('opensInNewTab') }})</span>
      </a>
      <a href="https://www.youtube.com/@katarraktisrefuge9897" target="_blank" rel="noopener noreferrer">
        <Icon :size="iconSize" name="mdi:youtube" aria-hidden="true"/>
        <span class="sr-only">{{ $t('visitYoutubePage') }} ({{ $t('opensInNewTab') }})</span>
      </a>
    </div>

    <nav class="all-links" :aria-label="$t('footerNavigation')">
      <div class="list">
        <nuxt-link style="font-weight: 700; font-size: xx-large" :to="localePath('/refuge')">{{ $t('The Refuge') }}</nuxt-link>
        <nuxt-link :to="localePath('/refuge/story')">{{ $t('Our Story') }}</nuxt-link>
        <nuxt-link :to="localePath('/refuge/booking')">{{ $t('Booking') }}</nuxt-link>
        <nuxt-link :to="localePath('/refuge/approach')">{{ $t('How to get here') }}</nuxt-link>
        <nuxt-link :to="localePath('/refuge/faq')">{{ $t('faqTitle') }}</nuxt-link>
        <nuxt-link :to="localePath('/refuge/photos')">{{ $t('Photos') }}</nuxt-link>
        <nuxt-link :to="localePath('/refuge/videos')">{{ $t('Videos') }}</nuxt-link>
      </div>
      <div class="list">
        <nuxt-link style="font-weight: 700; font-size: xx-large" :to="localePath('/services')">{{ $t('Services') }}</nuxt-link>
        <nuxt-link :to="localePath('/services/accommodation')">{{ $t('Accommodation') }}</nuxt-link>
        <nuxt-link :to="localePath('/services/menu')">{{ $t('Menu') }}</nuxt-link>
      </div>
      <div class="list">
        <nuxt-link style="font-weight: 700; font-size: xx-large" :to="localePath('/activities')">{{ $t('Activities') }}</nuxt-link>
        <nuxt-link :to="localePath('/activities/hiking-trails')">{{ $t('hikingTrails') }}</nuxt-link>
        <nuxt-link :to="localePath('/activities/alpine')">{{ $t('Alpine') }}</nuxt-link>
      </div>

    </nav>
    <div class="footer_copyright">
      <p>&copy; 2022 Christos Kordoulas</p>
      <!-- The name stays in Latin script in every locale, as the line above
           always has. -->
      <p class="created-by">{{ $t('createdBy') }} Ilias Kordoulas</p>
    </div>
  </footer>
</template>

<style lang="sass">
.all-links
  display: grid
  grid-template-columns: repeat(3, minmax(0, 1fr))
  width: 60%
  text-align: center

.list
  display: flex
  flex-direction: column

.social
  display: flex
  width: 10%
  justify-content: space-around
  margin-bottom: 10px

.footer_copyright
  text-align: center

  p
    margin: 0

  .created-by
    font-size: 0.85rem
    opacity: 0.6

.dark-mode .footer-container
  background-color: #141414

  a
    color: white

.footer-container
  padding: 20px
  width: 100vw
  min-height: 100px
  display: flex
  flex-direction: column
  align-items: center

  a
    color: rgb(30, 30, 30)
    text-decoration: none
    font-size: 1.4rem

    transition: all 100ms ease

    &:hover
      color: #60cca5
      cursor: pointer

@media screen and (max-width: 1280px)
  .footer-container
    padding: 20px 0

  .all-links
    grid-template-columns: repeat(1, 1fr)

  .social
    width: 100%
    justify-content: center
    margin-bottom: 10px

</style>
